import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { requireAuthenticatedUser } from '../../decorators'
import { getContactListData } from './mockData'
import type { TContact } from '~/types/contact/models'

interface GetContactsResponse {
  data: TContact[]
}

async function getContacts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetContactsResponse = { data: await getContactListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

export const handlers = [
  {
    method: 'get',
    path: '/api/contacts',
    handler: getContacts,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
